import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ENVIRONMENT } from '../../../../environments/environment';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-control-input-password',
  templateUrl: './control-input-password.component.html',
  styleUrl: './control-input-password.component.scss',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ControlInputPasswordComponent,
      multi: true,
    },
  ],
})
export class ControlInputPasswordComponent implements ControlValueAccessor {
  @Input() formControlName = '';
  @Input() placeholder = '';
  @Input() showIcon? = true;
  @Input() showVisibilityToggle? = true;
  @Output() userKeyup = new EventEmitter<KeyboardEvent>();

  value = '';
  isDisabled = false;
  fieldTextType = false;

  iconsStyle = ENVIRONMENT.FONTAWESOME.style;
  iconSize = 'fa-lg';

  readonly icons = {
    lock: 'fa-lock',
    eye: 'fa-eye',
    eyeSlash: 'fa-eye-slash',
  };

  onKeyup(event: KeyboardEvent): void {
    this.userKeyup.emit(event); // Emit the userKeyup event to the parent component
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: (value: string) => void = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  getInputValue(event: Event): string {
    const target = event.target as HTMLInputElement;
    return target.value;
  }

  toggleFieldTextType(isMouseDown: boolean) {
    this.fieldTextType = isMouseDown; // Set to true on mouse down, false otherwise
  }
}
